export enum ActionConfirmKind {
  NEWRUN = 0,
  RESTORE = 1,
  EXCLUDE = 2,
  PLAN = 3,
  CANCEL_PLAN = 4
}
